<template>
  <div class="yimiao">
    <div>
      <div>
        <van-cell-group>
          <span style="display: none;">{{ datafrom.OrgName }} {{ datafrom.OrgCode }}</span>
          <van-field v-model="datafrom.OrgName" required readonly="readonly" label="社区"/>
        </van-cell-group>
        <!-- 标题信息 -->
        <van-cell-group>
          <van-field v-model="datafrom.title" required label="标题" placeholder="请输入标题"/>
        </van-cell-group>

        <!-- <van-cell-group>
          <van-field v-model="datafrom.typeName" required @click="Rentalmethod = true" readonly="readonly" label="出租分类方式"
            placeholder="请选择出租分类方式" />
          <van-popup v-model="Rentalmethod" position="bottom" get-container="body">
            <van-picker show-toolbar :columns="Rentalname.map((item) => {
              return item.typeName
            })
              " value-key="name" @cancel="Rentalmethod = false" @confirm="onidRenta">
            </van-picker>
          </van-popup>
        </van-cell-group> -->


        <!-- <van-cell-group>
            <van-field v-model="datafrom.RoomType" required label="房型" placeholder="请输入房屋类型 如:3室2厅1卫" />
          </van-cell-group> -->

        <!-- <van-cell-group>
            <van-field v-model="datafrom.Area" required label="面积(㎡)" placeholder="请输入面积" />
          </van-cell-group> -->

        <!-- <van-cell-group>
            <van-field v-model="datafrom.Floor" required label="楼层" placeholder="请输入楼层,如7层" />
          </van-cell-group> -->
        <!-- <van-cell-group>
            <van-field v-model="datafrom.Toward" label="朝向" placeholder="请输入朝向,如南北" />
          </van-cell-group> -->

        <van-cell-group>
          <van-field v-model="datafrom.Price" required label="租金(元/月)" placeholder="请输入租金"/>
        </van-cell-group>

        <van-cell-group>
          <van-field v-model="datafrom.Deposit" required label="押金" placeholder="请输入押金,如:押一付三"/>
        </van-cell-group>

        <van-cell-group v-if="shopAdd != '3'">
          <van-field v-model="datafrom.Address" required label="详细地址" placeholder="请输入详细地址"/>
        </van-cell-group>

        <!-- <van-cell-group>
            <van-field v-model="datafrom.OpenHome" label="看房时间" placeholder="看房时间,如上午8:30" />
          </van-cell-group> -->

        <!-- <van-cell-group>
            <van-field v-model="datafrom.InRequire" label="入住要求" placeholder="请输入入住要求" />
          </van-cell-group> -->

        <!-- <van-cell-group>
            <van-field v-model="datafrom.Describe" label="房源描述" placeholder="请输入房源描述" />
          </van-cell-group> -->

        <van-cell-group v-if="shopAdd != '3'">
          <van-field v-model="datafrom.TouchMan" label="联系人" required placeholder="请输入联系人"/>
        </van-cell-group>

        <van-cell-group v-if="shopAdd != '3'">
          <van-field v-model="datafrom.TouchTel" label="联系电话" required placeholder="请输入联系电话"/>
        </van-cell-group>
        <!-- <van-field
            v-if="shopAdd != '3'"
            v-model="WorkTime[0]"
            label="开始营业时间"
            placeholder="请选择开始营业时间"
            readonly="readonly"
            @click="startTimeShow = true"
          /> -->
        <!-- <van-popup
            v-model="startTimeShow"
            position="bottom"
            get-container="body"
          >
            <van-datetime-picker
              show-toolbar
              type="time"
              title="选择年月日时分"
              @cancel="startTimeShow = false"
              @confirm="onstartTimeShow"
            >
            </van-datetime-picker>
          </van-popup> -->
        <!-- <van-field
            v-if="shopAdd != '3'"
            v-model="WorkTime[1]"
            label="结束营业时间"
            placeholder="请选择结束营业时间"
            readonly="readonly"
            @click="endTimeShow = true"
          /> -->
        <!-- <van-popup v-model="endTimeShow" position="bottom" get-container="body">
            <van-datetime-picker
              show-toolbar
              type="time"
              title="选择年月日时分"
              @cancel="endTimeShow = false"
              @confirm="onendTimeShow"
            >
            </van-datetime-picker>
          </van-popup> -->
        <!-- 富文本编辑器 -->
        <div class="submit" style="padding: 10px 7px" v-if="shopAdd != '3'">
          <span style="color: red; font-size: 14px; letter-spacing: 8px"></span>
          <span style="color: #646566; font-size: 14px">内容</span>
        </div>
        <div style="width:90%;margin:auto;" required>
          <Editor :value.sync="datafrom.content"/>
        </div>
        <!-- 备注 -->
        <!-- <van-field
            v-if="shopAdd != '3'"
            v-model="datafrom.Remark"
            rows="3"
            autosize
            label="备注"
            type="textarea"
            placeholder="备注"
            style="margin-top: 15px"
          /> -->
        <!-- 照片 -->
        <div class="submit" style="padding: 10px 7px" v-if="shopAdd != '3'">
          <span style="color: red; font-size: 14px; letter-spacing: 8px"></span>
          <span style="color: #646566; font-size: 14px">照片</span>
        </div>
        <!-- <div v-if="detailsId">
          <img v-for="(item,index) in detailsImageList" :src="item" :key="index" alt="">
        </div> -->
        <van-uploader v-if="shopAdd != '3'" v-model="jkImageList" multiple capture="camera" class="imgs" :max-count="1"
                      :after-read="afterRead" :before-delete="jkDelete" :deletable="true"/>
        <van-cell-group v-if="shopAdd == 3">
          <van-field v-model="datafrom.OriTouchTel" label="原联系方式" required placeholder="请输入原联系方式"/>
          <van-field v-model="TouchTel" label="绑定联系方式" required placeholder="请输入绑定联系方式"/>
        </van-cell-group>
        <van-cell-group v-if="ShopCate == 1">
          <van-field v-model="datafrom.ICode" label="行业" placeholder="请输入行业"/>
        </van-cell-group>
        <van-cell-group v-if="ShopCate == 1">
          <van-cell required title="是否重点监控">
            <van-radio-group v-model="datafrom.IsMonitor" direction="horizontal">
              <van-radio name="1">是</van-radio>
              <van-radio name="2">否</van-radio>
            </van-radio-group>
          </van-cell>
        </van-cell-group>

        <van-cell-group v-if="ShopCate == 1">
          <van-field v-model="datafrom.FireType" required label="消防器材类型" placeholder="请输入消防器材类型"/>
        </van-cell-group>
        <van-cell-group v-if="ShopCate == 1">
          <van-field v-model="datafrom.YearCheckTime" label="消防年检日期" @click="datafromOutTime = true"
                     readonly="readonly"
                     required placeholder="请选择消防器材年检日期"/>
          <van-popup v-model="datafromOutTime" position="bottom" get-container="body">
            <van-datetime-picker show-toolbar type="date" title="请选择消防器材年检日期" :min-date="minDate"
                                 :max-date="maxDate"
                                 @cancel="datafromOutTime = false" @confirm="ondatafromOutTime">
            </van-datetime-picker>
          </van-popup>
        </van-cell-group>
        <van-cell-group v-if="ShopCate == 1">
          <van-field v-model="datafrom.FireCount" required label="消防器材数量" placeholder="请输入消防器材数量"/>
        </van-cell-group>
        <!-- <van-cell-group>
            <van-field
              v-model="datafrom.Address"
              label="详细地址"
              placeholder="请输入详细地址"
            />
          </van-cell-group> -->
        <!-- <van-cell-group>
            <van-field
              v-model="datafrom.License"
              label="营业执照"
              placeholder="请输入营业执照编号"
            />
          </van-cell-group> -->
        <!-- <van-cell-group v-if="shopAdd != '3'">
          <van-cell required title="状态">
            <van-radio-group v-model="datafrom.Status" direction="horizontal">
              <van-radio name="1">租赁中</van-radio>
              <van-radio name="2">已出租</van-radio>
              <van-radio name="3">已下架</van-radio>
            </van-radio-group>
          </van-cell>
        </van-cell-group> -->
        <van-cell-group v-if="shopAdd != '3'">
          <van-cell title="获取当前定位">
            <van-radio-group v-model="dwIndex" direction="horizontal">
              <van-radio name="1" @click="dwXuanze(1)">是</van-radio>
              <van-radio name="2" @click="dwXuanze(2)">否</van-radio>
            </van-radio-group>
          </van-cell>
        </van-cell-group>
        <div id="allmap" v-show="dWshow" style="height: 160px; width: 90%; margin: auto"></div>
      </div>
      <!-- <div class="buttons">
            <van-button type="info" @click="postfrom()">提交</van-button>
          </div> -->

      <div class="buttons">
        <van-button type="info" style="margin: 10px 0" v-if="bangdingShow" @click="postfrom(1)">提交</van-button>
        <van-button type="info" style="margin: 10px 0" v-if="!bangdingShow" @click="postfrom(2)">微信绑定</van-button>
        <van-button style="border: 1px solid #e6e6e6; margin: 10px 0" type="
              default" @click="fanhui()">返回
        </van-button>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript" src="//api.map.baidu.com/api?v=3.0&ak=L2s5R0CE405alnjKlsp35mNTySNAvZtd"></script>
<script>
import Vue from 'vue'
import {Dialog} from 'vant'
import {Toast} from 'vant'
import config from '@/config'
import Compressor from 'compressorjs'
import axios from 'axios'
import {loadBMap} from '../../fangyi/baiduLocation.js'

Vue.use(Toast)
import {
  WeGetRegionList,
  WeGetBuildRoomList,
  WeGetAppletOrganList,
  GetOrgansNullToken,
  WxReBindFnRoom,
  WxIsMember
} from '@/api/Changan-zhsq/yeguang'
import {WxSaveMyLease, WxGetLease} from '@/api/Changan-zhsq/evaluating'
import Editor from "@/components/EditorUser";

export default {
  components: {
    [Dialog.Component.name]: Dialog.Component,
    Editor
  },
  data() {
    return {
      startTimeShow: false, //开始时间弹框
      endTimeShow: false, //结束时间弹框
      currentDate: '12:00',
      minHour: 10,
      maxHour: 20,
      ShopCate: '',
      // 营业执照
      jkImageList: [],
      //商铺图片
      ShopImgList: [],
      OrganList: [],
      Rentalname: [{id: '1', Name: '整租'},
        {id: '1', Name: '合租'},],
      RentalId: '',
      ridlist: [],
      BIdlist: [],
      BUIdlist: [],
      BFIdlist: [],
      BRIdlist: [],
      diqu: [],
      guanxi: [],
      minzu: [],
      xveli: [],
      zhuangtai: [],
      hunyin: [],
      ocodelist: [],
      minDate: new Date(2021, 0),
      maxDate: new Date(2025, 0),
      NativeCantonCodedata: [],
      dwIndex: '2',
      sexlist: [
        {id: '1', Name: '男'},
        {id: '2', Name: '女'},
      ],
      yimiaolist: [
        {id: '0', Name: '未接种'},
        {id: '1', Name: '第一针'},
        {id: '2', Name: '第二针'},
      ],
      idList: {
        organCode: '',
        RId: undefined,
      },
      datafrom: {
        LeaseId: 0, //id、
        RoomSource: '', // 名称、
        OrgCode: '',
        Remark: '',
        Imgs: '',
        LeaseMode: '', //出租方式id
        Area: '', //房屋面积
        RoomType: '', //房屋类型
        Floor: '', //房屋楼层
        Toward: '', //房屋朝向
        Price: '', //房子租金
        Deposit: '', //房屋押金
        OpenHome: '', //看房时间
        InRequire: '', //入住要求
        Describe: '', //房源描述
        Address: '',
        Coordinate: '', // 地图坐标
        TouchMan: '', // 联系人、
        TouchTel: '', // 手机、
        Status: '1',
        Remark: '', // 备注
        // 新增的字段
        content: '',//富文本内容
        title: '',//标题
        typeName: '',//出租分类方式
        typeId: ''
      },
      TouchTel: '',
      shopType: [],
      shopType1: [],
      shopLevel: [
        {name: '一星', val: 1},
        {name: '二星', val: 2},
        {name: '三星', val: 3},
        {name: '四星', val: 4},
        {name: '五星', val: 5},
      ],
      WorkTime: [],
      shopTypePicker: false, //商铺类型
      shopTypePicker1: false, //商铺等级
      shopTypePicker2: false, //邻里中心
      idListRId: false,
      idListOrg: false,
      Rentalmethod: false,
      addshow: false,
      verifyshow: true,
      OCodeshow: false,
      OLeaseMode: false,
      sexshow: false,
      Nationshow: false,
      yimiao: false,
      datafromBackTime: false,
      datafromOutTime: false,
      dWshow: false,
      bangdingShow: true,
      bjZuoBiao: '',
      shopAdd: this.$route.query.add,
      cascaderValues: '',
      detailsId: ''
    }
  },
  created() {
    this.detailsId = this.$route.params.id
    if (this.$route.params.id && this.$route.params.id != 'null' && this.$route.params.id != 'undefined') {
      this.wxGetPromotion()
    } else {
      this.$route.params.id = ''
    }
    this.GetOrgansNullToken()
    this.shopXq()
    this.openId = this.$route.params.openId
    console.log(this.$route.query, 1212)
    this.MemberInfo()
  },

  methods: {
    MemberInfo() {
      WxIsMember({OpenID: this.openId}).then((res) => {
        if (res.data.code == "0") {
          const data = res.data.data
          console.log(data)
          this.datafrom.OrgName = data.OrgName
          this.datafrom.OrgCode = data.OrgCode
          console.log(this.datafrom);
        } else {
          this.verifyshow = 0;
          Toast.fail(res.data.msg);
        }
      });
    },
    // 获取房源详情
    wxGetPromotion() {

      this.goodsid = this.$route.params.id;
      let params = {
        LeaseId: this.goodsid,
        OpenID: this.$route.query.openid
      }
      WxGetLease(params).then((res) => {
        // console.log(res,5252);
        this.datafrom = res.data.data;
        // this.datafrom.content = res.data.data.content
        this.detailsImageList = res.data.data.Imgs ? res.data.data.Imgs.split(',') : []
        // this.getshoppingList(this.orderid);
      });
    },
    // 社区搜索
    onFinish({selectedOptions}) {
      // console.log(val, 'val')

      const fieldValue = selectedOptions.map((option) => option.OrganName).join('/')
      this.datafrom.OrgName = fieldValue
      this.datafrom.OrgCode = selectedOptions[selectedOptions.length - 1].OrganCode

      this.cascaderValues = this.datafrom.OrgCode

      // this.datafrom.OrgCode = val.organcode
      // this.datafrom.OrgName = val.organname
      this.idListOrg = false
    },
    onstartTimeShow(val) {
      this.WorkTime[0] = val
      this.startTimeShow = false
    },
    onendTimeShow(val) {
      this.WorkTime[1] = val
      this.endTimeShow = false
    },
    onInput(event) {
      this.setData({
        currentDate: event.detail,
      })
    },
    shopXq: function () {
      console.log(this.$route.query)
      if (this.$route.query.add == '1') {
        this.datafrom = {
          OpenID: '',
          LeaseId: 0, //id、
          RoomSource: '', // 名称、
          OrgCode: '',
          Remark: '',
          Imgs: '',
          LeaseMode: '', //出租方式id
          Area: '', //房屋面积
          RoomType: '', //房屋类型
          Floor: '', //房屋楼层
          Toward: '', //房屋朝向
          Price: '', //房子租金
          Deposit: '', //房屋押金
          OpenHome: '', //看房时间
          InRequire: '', //入住要求
          Describe: '', //房源描述
          Address: '',
          Coordinate: '', // 地图坐标
          TouchMan: '', // 联系人、
          TouchTel: '', // 手机、
          Status: '1',
          Remark: '', // 备注
          // 新增字段
          content: '',//内容
          title: '',//标题
        }
      } else if (this.$route.query.add == '2' || this.$route.query.add == '3') {
        WxGetLease(this.$route.query.LeaseId).then((res) => {
          this.bangdingShow = true
          if (res.data.code == 0) {
            this.datafrom = res.data.data
            console.log(res.data.data, '000000000')
            //重点监控
            this.bjZuoBiao = res.data.data.Coordinate
            // this.WorkTime[0] = res.data.data.WorkTime.split("-")[0];
            // this.WorkTime[1] = res.data.data.WorkTime.split("-")[1];
            // this.datafrom.IsMonitor = res.data.data.IsMonitor + "";
            this.datafrom.Status = res.data.data.Status + ''
            this.datafrom.OrgCode = res.data.data.OrgCode
            this.datafrom.OrgName = res.data.data.OrgName
            // this.datafrom.Region = res.data.data.RName;
            this.datafrom.STypeId = res.data.data.STypeId
            this.datafrom.STypeDesc = res.data.data.STypeDesc
            if (res.data.data.LeaseMode == 1) {
              this.datafrom.LeaseModeDesc = '整租'
            } else if (res.data.data.LeaseMode == 2) {
              this.datafrom.LeaseModeDesc = '合租'
            }
            // this.RegionList(res.data.data.OCode)
            console.log(res.data.data)
            //商铺照片
            if (res.data.data.Logo != '') {
              this.ShopImgLists = [res.data.data.Logo]
              var arr = []
              this.ShopImgLists.forEach(function (imgUrl) {
                arr.push({url: imgUrl})
              })
              this.ShopImgList = arr
              this.datafrom.Logo = res.data.data.Logo
            }
            if (res.data.data.Imgs != '') {
              //营业执照
              this.jkImageLists = [res.data.data.Imgs]
              var arrYe = []
              this.jkImageLists.forEach(function (imgUrl) {
                arrYe.push({url: imgUrl})
              })
              this.jkImageList = arrYe
              this.datafrom.Imgs = res.data.data.Imgs
            }
            // this.datafrom.ShopTypeKind = res.data.data.ShopTypeKind;
            // this.datafrom.STypeDesc = res.data.data.ShopTypeDesc;
            // this.datafrom.Region = res.data.data.RName;
            // this.datafrom.IsMonitor = res.data.data.IsMonitor;
          }
          if (this.$route.query.add == '3') {
            this.bangdingShow = false
          }
        })
      }
    },
    dwXuanze: function (row) {
      if (row == '1') {
        this.dingwei()
        this.dWshow = true
      } else {
        this.dWshow = false
        this.Coordinate = this.bjZuoBiao
      }
    },
    dingwei: function () {
      var that = this
      // 百度地图API功能
      window.initBaiduMapScript = () => {
        that.BMap = window.BMap
        var map = new window.BMap.Map('allmap')
        var point = new that.BMap.Point(116.331398, 39.897445)
        map.centerAndZoom(point, 18)

        var geolocation = new that.BMap.Geolocation()
        var Coordinate = ''
        geolocation.getCurrentPosition(
            function (r) {
              if (this.getStatus() == BMAP_STATUS_SUCCESS) {
                var mk = new BMap.Marker(r.point)
                map.addOverlay(mk)
                map.panTo(r.point)
                this.Coordinate = [{lng: r.point.lng, lat: r.point.lat, of: 'inner'}]
                console.log(this.Coordinate, "CoordinateCoordinateCoordinate")
                that.dingweiList(this.Coordinate)
                // alert('您的位置：' + r.point.lng + ',' + r.point.lat);
              } else {
                alert('failed' + this.getStatus())
              }
            },
            {enableHighAccuracy: true}
        )
        console.log(geolocation)
        this.dingweiList(geolocation)
      }
      loadBMap('initBaiduMapScript')
    },
    dingweiList: function (geolocation) {
      console.log(geolocation)
      this.Coordinate = geolocation
    },
    // 确认商铺类型
    shopTypeQr(val) {
      this.datafrom.STypeId = val.STypeId
      this.datafrom.STypeDesc = val.Name
      this.shopTypePicker = false
    },
    // 确认商铺等级
    shopTypeQr1(val) {
      console.log(val, '选中等级')
      this.datafrom.Level = val.val
      this.datafrom.LevelDesc = val.name
      this.shopTypePicker1 = false
    },
    // 确认商铺等级
    shopTypeQr3(val) {
      console.log(val, '选中邻里中心')
      this.datafrom.NeInfoId = val.InfoId
      this.datafrom.NeInfoName = val.Name
      this.shopTypePicker2 = false
    },
    //上传营业执照
    afterRead(file) {
      var that = this
      file.status = 'uploading'
      file.message = '上传中...'
      new Compressor(file.file, {
        quality: 0.5,
        success(result) {
          var formData = new FormData()
          let c = {
            headers: {'Content-Type': 'multipart/form-data'},
          }
          //构造一个 FormData，把后台需要发送的参数添加
          formData.append('file', result, result.name)
          formData.append("fileName", file.file.name);
          formData.append("openId", this.openId);
          axios.post(config.apiUploadUrlWX, formData, c).then((res) => {
            if (res.data.code === 0) {
              console.log(res.data.msg)
              that.datafrom.Imgs = res.data.msg
              // that.datafrom.EvalImgs.push(res.data.data);
              file.status = ''
              file.message = ''
            } else {
              Toast.fail(res.data.msg);
              //删除图片
              this.fileList = [];
              this.shanchu();
            }
          })
        },
      })
    },
    //删除营业执照
    jkDelete(file) {
      this.jkImageList = []
      this.datafrom.Imgs = ''
    },
    //上传商铺图片
    ShopImgRead(file) {
      var that = this
      file.status = 'uploading'
      file.message = '上传中...'
      new Compressor(file.file, {
        quality: 0.5,
        success(result) {
          var formData = new FormData()
          let c = {
            headers: {'Content-Type': 'multipart/form-data'},
          }
          //构造一个 FormData，把后台需要发送的参数添加
          formData.append('file', result, result.name)
          axios.post(config.apiUploadUrl, formData, c).then((res) => {
            if (res.data.code === 0) {
              console.log(res.data.picurl)
              that.datafrom.Logo = res.data.picurl[0]
              // that.datafrom.EvalImgs.push(res.data.data);
              file.status = ''
              file.message = ''
            } else {
              Toast.fail(res.data.msg)
            }
          })
        },
      })
    },
    //删除商铺图片
    xcDelete(file) {
      this.ShopImgList = []
      this.datafrom.Logo = ''
    },
    //上传核酸证明
    afterhsRead(file) {
      var that = this
      file.status = 'uploading'
      file.message = '上传中...'
      new Compressor(file.file, {
        quality: 0.5,
        success(result) {
          var formData = new FormData()
          let c = {
            headers: {'Content-Type': 'multipart/form-data'},
          }
          //构造一个 FormData，把后台需要发送的参数添加
          formData.append('file', result, result.name)
          axios.post(config.apiUploadUrl, formData, c).then((res) => {
            if (res.data.code === 0) {
              console.log(res.data.data)
              that.datafrom.Testify = res.data.data
              // that.datafrom.EvalImgs.push(res.data.data);
              file.status = ''
              file.message = ''
            } else {
              Toast.fail(res.data.msg)
            }
          })
        },
      })
    },
    //删除核酸
    hsDelete(file) {
      this.hsImageList = []
      this.datafrom.Testify = ''
    },
    // 提交
    postfrom: function (row) {
      console.log(this.datafrom, 'dzx123123')
      if (this.ShopCate == 1) {


        if (this.datafrom.content == '') {
          Toast.fail('请输入详情介绍')
          return false
        }
          if (this.datafrom.OrgCode == '') {
          Toast.fail('请选择社区')
          return false
        }
        if (this.datafrom.Price == '') {
          Toast.fail('请输入租金')
          return false
        }
        if (this.datafrom.Deposit == '') {
          Toast.fail('请输入押金')
          return false
        }
        // if (this.datafrom.License == "") {
        //   Toast.fail("请输入门牌号");
        //   return false;
        // }
        if (this.datafrom.TouchMan == '') {
          Toast.fail('请输入联系人')
          return false
        }
        if (this.datafrom.TouchTel == '') {
          Toast.fail('请输入联系电话')
          return false
        }
        // if (this.datafrom.STypeDesc == "") {
        //   Toast.fail("请选择商品类型");
        //   return false;
        // }

        // if (this.datafrom.YearCheckTime == "") {
        //   Toast.fail("请选择消防器材年检日期");
        //   return false;
        // }
        // if (this.datafrom.FireCount == "") {
        //   Toast.fail("请输入消防器材数量");
        //   return false;
        // }
        // if (this.datafrom.FireType == "") {
        //   Toast.fail("请输入消防器材类型");
        //   return false;
        // }
        if (this.datafrom.Address == '') {
          Toast.fail('请输入详细地址')
          return false
        }
      } else {
        console.log(2222222);

        if (this.datafrom.title == '') {
          Toast.fail('请输入标题')
          return false
        }
        if (this.datafrom.OrgCode == '') {
          Toast.fail('请选择社区')
          return false
        }
        // if(this.datafrom.typeName==''){
        //   Toast.fail('请选择出租类型')
        //   return false
        // }
        // if (this.datafrom.NeInfoId == '') {
        //   Toast.fail('请选择邻里中心')
        //   return false
        // }
        // if (this.datafrom.RoomSource == '') {
        //   Toast.fail('请输入名称')
        //   return false
        // }
        // if (this.datafrom.RoomType == '') {
        //   Toast.fail('请输入房屋类型')
        //   return false
        // }
        // if (this.datafrom.Area == '') {
        //   Toast.fail('请输入面积')
        //   return false
        // }
        // if (this.datafrom.Floor == '') {
        //   Toast.fail('请输入楼层')
        //   return false
        // }
        if (this.datafrom.Price == '') {
          Toast.fail('请输入租金')
          return false
        }
        if (this.datafrom.Deposit == '') {
          Toast.fail('请输入押金')
          return false
        }
        if (this.datafrom.Address == '') {
          Toast.fail('请输入详细地址')
          return false
        }
        if (this.datafrom.TouchMan == '') {
          Toast.fail('请输入联系人')
          return false
        }
        if (this.datafrom.TouchTel == '') {
          Toast.fail('请输入联系电话')
          return false
        }

      }
      this.datafrom.Status = 0
      this.datafrom.OpenID = this.openId
      // this.datafrom.OpenID = "ojciF5FL_BlLHTSPhVIfIQz_KR48";
      this.ShopCate = this.$route.query.shopCate
      // this.datafrom.OpenID = "123321";
      if (this.Coordinate == '') {
        this.datafrom.Coordinate = ''
      } else {
        if (this.dWshow) {
          this.datafrom.Coordinate = JSON.stringify(this.Coordinate)
        } else {
          this.datafrom.Coordinate = this.bjZuoBiao
        }
      }
      // this.datafrom.WorkTime = this.WorkTime.join("-");
      // this.datafrom.IsMonitor = Number(this.datafrom.IsMonitor);
      if (row == '1') {
        WxSaveMyLease(this.datafrom).then((res) => {
          if (res.data.code == 0) {
            console.log(this.datafrom, 'dzx1234567890')
            console.log(res.data)
            Dialog.alert({
              title: '提示',
              message: '提交成功!',
            }).then(() => {
              if (window.__wxjs_environment === "miniprogram") {
                window.wx.miniProgram.navigateBack({
                  delta: 1
                });
              } else {
                this.$router.go(-1)
              }

              // this.$router.push({
              //   name: "register",
              // });
            })
          } else {
            Dialog.alert({
              title: '提示',
              message: '提交失败!' + res.data.msg,
            }).then(() => {
              // this.datafrom.IsMonitor = this.datafrom.IsMonitor + "";
              // on close
            })
          }
        })
      } else if (row == '2') {
        this.datafrom.TouchTel = this.TouchTel
        WxReBindFnRoom(this.datafrom).then((res) => {
          if (res.data.code == 0) {
            Dialog.alert({
              title: '提示',
              message: '绑定成功!',
            }).then(() => {
              this.$router.go(-1)
              // this.$router.push({
              //   name: "register",
              // });
            })
          } else {
            Dialog.alert({
              title: '提示',
              message: '提交失败!' + res.data.msg,
            }).then(() => {
              // this.datafrom.IsMonitor = this.datafrom.IsMonitor + "";
              // on close
            })
          }
        })
      }
    },
    gitocodelist() {
      GetOrgansNullToken().then((res) => {
        this.ocodelist = res.data.data
      })
    },
    // 社区列表
    GetOrgansNullToken: function (row) {
      GetOrgansNullToken({level: 4, kind: 1, openId: this.$route.params.openId}).then((res) => {
        this.OrganList = res.data.data
      })
    },
    // 小区(组)列表
    RegionList: function (row) {
      WeGetRegionList({organCode: row}).then((res) => {
        this.ridlist = res.data.data
      })
    },
    // 房屋列表
    BuildRoomList: function (val) {
      WeGetBuildRoomList({
        bId: this.idList.BId,
        buId: this.idList.buId,
        bfId: val,
      }).then((res) => {
        console.log(res)
        this.BRIdlist = res.data.data
      })
    },
    fanhui: function () {
      if (window.__wxjs_environment === "miniprogram") {
        window.wx.miniProgram.navigateBack({
          delta: 1
        });
      } else {
        this.$router.go(-1)
      }
    },
    // 社区选择器
    onidListOrg(val) {
      console.log(this.datafrom, '0523')
      this.datafrom.OrgCode = val.organcode

      this.datafrom.OrgName = val.organname
      console.log(val, '987654321')
      this.idListOrg = false
      this.RegionList(val.organcode)
      console.log(this.OrganList)
      // this.datafrom.Region = "";
      // this.BuildList(val.RId);
    },
    //出租方式
    onidRenta(val, id) {
      console.log(val, id);
      this.datafrom.typeName = val
      this.datafrom.typeId = this.Rentalname[id].id
      console.log(this.datafrom.typeId);
      // this.datafrom.typeId = id
      this.Rentalmethod = false
      // this.RentalId = this.Rentalname.find((item) => item.name == val)
      // this.datafrom.LeaseMode = this.RentalId.id
      // console.log(this.datafrom, '6010')
    },

    // 小区(组)选择器
    onidListRId(val) {
      this.datafrom.RId = val.RId
      // this.datafrom.Region = val.Title;
      this.idListRId = false
      this.BuildList(val.RId)
    },
    // 性别选择器
    onsexshow(val) {
      this.datafrom.sex = val.id
      this.datafrom.sexName = val.Name
      this.sexshow = false
    },

    // 消防器材年检日期
    ondatafromOutTime(val) {
      this.datafrom.YearCheckTime = this.dateformat(val)
      this.datafromOutTime = false
    },
    // 社区
    onocode(val) {
      this.datafrom.OrgName = val.selectedOptions[0].OrganName
      this.RegionList(val.value)
      this.OCodeshow = false
    },
    dateformat(val) {
      // 时间格式化事件 yy-mm-dd
      // let year = val.getFullYear();
      // let month = val.getMonth() + 1;
      // let day = val.getDate();
      let houser = val.getHours()
      let Minutes = val.getMinutes()
      if (month >= 1 && month <= 9) {
        month = `0${month}`
      }
      if (day >= 1 && day <= 9) {
        day = `0${day}`
      }
      if (houser >= 1 && houser <= 9) {
        houser = `0${houser}`
      }
      if (Minutes >= 1 && Minutes <= 9) {
        Minutes = `0${Minutes}`
      }
      // return `${year}-${month}-${day} ${houser}:${Minutes}`;
      return `${year}-${month}-${day}`
    },
  },

}
</script>
<style>
.imgs {
  margin: 0 15px;
}

.yimiao .inputFrom {
  margin: 15px 8%;
}

.yimiao .inputFrom input {
  width: 80%;
  margin: 8px 8%;
  padding: 8px 5px;
  font-size: 14px;
  border: 1px solid #e6e6e6;
}

.yimiao .buttons {
  text-align: center;
}

.yimiao .buttons button {
  width: 90%;
  margin: 25px 5%;
  border-radius: 10px;
}

.buttons {
  text-align: center;
}

.buttons button {
  margin: 25px 10px;
  border-radius: 10px;
}
</style>
